import { useContext } from "@nuxtjs/composition-api";
import { AnalyticsError } from "~/helpers/error";

export function useTrackProfessionViewContent() {
  const { $track, $sentry } = useContext();

  function trackProfessionViewContent(profession) {
    if (!profession) {
      return;
    }
    try {
      $track.customEvent({
        event: "Facebook.track",
        content: {
          eventName: "ViewContent",
          eventData: {
            content_name: profession.seoName,
            content_category: profession.professionGroup?.seoName,
            content_ids: [profession.id],
            content_type: "profession",
          },
        },
      });
    } catch (err) {
      $sentry?.captureException(new AnalyticsError(err), {
        tags: { analytics: "rft", rft: "set_profession" },
      });
    }
  }

  return {
    trackProfessionViewContent,
  };
}
